export default __webpack_public_path__ + "static/media/maintenance_completed_on.c713d450.svg";